/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ServicedeskCmdbObjectSchemaType from '@jira/spa-apps__servicedesk-cmdb-object-schema-v2/src/ConditionalRedirectOrRouteView.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskCmdbObjectSchemaV2: LazyComponent<() => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof ServicedeskCmdbObjectSchemaType>(
		() =>
			import(
				/* webpackChunkName: "async-servicedesk-cmdb-object-schema-v2", jiraSpaEntry: "async-servicedesk-object-schema-v2" */ '@jira/spa-apps__servicedesk-cmdb-object-schema-v2/src/ConditionalRedirectOrRouteView.tsx'
			),
		{ ssr: false },
	);

export const ObjectSchemaV2 = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskCmdbObjectSchemaV2}
		pageId="spa-apps/servicedesk/insight/cmdb-object-schema"
		shouldShowSpinner
	/>
);

export default ObjectSchemaV2;
